import { useState, useEffect } from "react";
import { Box, TextField, Button } from "@mui/material";
import { UseMotorDelivery } from "./UseMotorDelivery";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "leaflet/dist/leaflet.css";
import MapComponent from "./MapComponent";
import RoutsLists from "./RoutsLists";
import AssignDriver from "./AssignDriver";
import OrdersListGrid from "./OrdersListGrid";
import DriversCom from "./DriversCom";
import { toSolar } from "jdate-convert";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function MotorDelivery() {
  const { enqueueSnackbar } = useSnackbar();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [valueDate, setValueDate] = useState();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [routSelect, setroutSelect] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    GetDriversRoutes,
    GetOrdersRoute,
    GetGroupsPart,
    GetOrderByLogesticId,
    getParts,
  } = UseMotorDelivery();
  const { myPc, refresh } = UseMyPC();
  const [refreshDriver, setRefreshDriver] = useState(false);
  const [changeZoom, setChangeZoom] = useState(false);
  const [changeCenter, setChangeCenter] = useState(false);
  const [locations, setLocations] = useState();
  const [orders, setOrders] = useState({ orders: [], driverID: undefined });
  const [routes, setRoutes] = useState();
  const [oneOrderSearch, setOneOrderSearch] = useState();
  const [isSearch, setIsSearch] = useState(false);
  const [parts, setParts] = useState();
  const [filters, setFilters] = useState({
    deliveryDate: new Date().toJSON().slice(0, 10),
    deliveryPart: undefined,
  });
  const [orderModel, setOrderModel] = useState({
    deliveryDate: new Date().toJSON().slice(0, 10),
    deliveryPart: undefined,
    zoneIndex: undefined,
  });
  const [assignModel, setAssignModel] = useState({
    deliveryDate: new Date().toJSON().slice(0, 10),
    deliveryPart: undefined,
    zoneIndex: undefined,
    orderID: undefined,
    driverID: undefined,
  });
  const [mapCenter, setMapCenter] = useState([35.7009, 51.391241]);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setProgress(true);
    getParts(myPc, (parts) => {
      setFilters({
        ...filters,
        deliveryPart: parts.parts[0].id,
      });
      setAssignModel({
        ...assignModel,
        deliveryPart: parts.parts[0].id,
      });
      setOrderModel({
        ...orderModel,
        deliveryPart: parts.parts[0].id,
      });
      setParts(parts);
    });
  }, [myPc]);

  useEffect(() => {
    if (orders) {
      const element = document.getElementById("driversOrder");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 1000);
    }
  }, [orders]);

  useEffect(() => {
    if (filters.deliveryDate && filters.deliveryPart) {
      setOneOrderSearch("");
      localStorage.removeItem("DriverModel");
      setOrders();
      setroutSelect();
      setRoutes();
      setOrderModel({
        deliveryDate: undefined,
        deliveryPart: undefined,
        zoneIndex: undefined,
      });
      setAssignModel({
        deliveryDate: undefined,
        deliveryPart: undefined,
        zoneIndex: undefined,
        orderID: undefined,
        driverID: undefined,
      });
      setLocations([]);
      setChangeZoom(true);
      setProgress(true);
      GetGroupsPart(
        filters.deliveryDate,
        filters.deliveryPart,
        (Routes) => {
          if (Routes) {
            setRoutes(Routes);
          } else {
            setRoutes();
          }
        },
        true
      );
    }
  }, [filters]);

  useEffect(() => {
    refresh();
  }, []);

  useEffect(() => {
    if (valueDate) {
      let newValueStart = valueDate?.toDate?.().toLocaleDateString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      setAssignModel({ ...assignModel, deliveryDate: newValueStart });
      setOrderModel({ ...orderModel, deliveryDate: newValueStart });
      setFilters({ ...filters, deliveryDate: newValueStart });
    }
  }, [valueDate]);

  function refreshPage() {
    setRefreshDriver(true);
    setProgress(true);
    GetGroupsPart(
      filters.deliveryDate,
      filters.deliveryPart,
      (Routes) => {
        if (Routes) {
          setRoutes(Routes);
        } else {
          setRoutes();
        }
      },
      false
    );
    if (orders?.driverID) {
      let model = {
        deliveryDate: filters.deliveryDate,
        deliveryPart: filters.deliveryPart,
        driverID: orders?.driverID,
      };
      GetDriversRoutes(model, (orders) => {
        setChangeZoom(true);
        setLocations(orders.orders);
        setOrders(orders);
      });
    }
  }

  return (
    <Detail
      breadChilds={{
        title: "لجستیک",
        childs: [{ name: msActiveMenu.pageTitle, url: "/motordelivery" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "auto" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: isSmall ? "flex-start" : "center",
            justifyContent: "space-between",
            flexDirection: isSmall ? "column" : "row",
            gap: 2,
            width: "100%",
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 3, zIndex: 1000 }}
          >
            <DatePicker
              // highlightToday={false}
              onOpenPickNewDate={false}
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={filters.deliveryDate ? toSolar(filters.deliveryDate) : ""}
              onChange={setValueDate}
              render={
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ"
                />
              }
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {parts &&
                parts.parts.map((part) => {
                  return (
                    <Button
                      sx={{ width: "100px" }}
                      startIcon={
                        filters.deliveryPart == part.id && <CheckIcon />
                      }
                      variant={
                        filters.deliveryPart == part.id
                          ? "contained"
                          : "outlined"
                      }
                      color={
                        filters.deliveryPart == part.id
                          ? "secondary"
                          : "primary"
                      }
                      key={part.id}
                      onClick={() => {
                        setAssignModel({
                          ...assignModel,
                          deliveryPart: part.id,
                        });
                        setOrderModel({ ...orderModel, deliveryPart: part.id });
                        setFilters({ ...filters, deliveryPart: part.id });
                      }}
                    >
                      {part.title}
                    </Button>
                  );
                })}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isSmall ? "flex-start" : "flex-end",
              gap: 1,
            }}
          >
            <TextField
              sx={{
                width: "50%",
                input: {
                  textAlign: "center",
                },
              }}
              value={oneOrderSearch ? oneOrderSearch : ""}
              label="سفارش"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setOneOrderSearch(evt.target.value);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  let model = {
                    deliveryDate: filters.deliveryDate,
                    deliveryPart: filters.deliveryPart,
                    orderID: Number(oneOrderSearch),
                  };
                  GetOrderByLogesticId(model, (callback) => {
                    if (callback && callback.id !== 0) {
                      setIsSearch(true);
                      setLocations([callback]);
                      setOrderModel({
                        ...orderModel,
                        orderID: callback.id,
                        zoneIndex: undefined,
                      });
                      setAssignModel({
                        ...assignModel,
                        orderID: callback.id,
                        zoneIndex: undefined,
                        driverID: undefined,
                      });
                      setOrders();
                      setroutSelect();
                      setChangeZoom(true);
                    } else {
                      enqueueSnackbar("سفارشی یافت نشد", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      setOneOrderSearch("");
                      setLocations([]);
                      return;
                    }
                  });
                }
              }}
            />
            <Button
              variant="contained"
              onClick={() => {
                let model = {
                  deliveryDate: filters.deliveryDate,
                  deliveryPart: filters.deliveryPart,
                  orderID: Number(oneOrderSearch),
                };
                GetOrderByLogesticId(model, (callback) => {
                  if (callback && callback.id !== 0) {
                    setIsSearch(true);
                    setLocations([callback]);
                    setOrderModel({
                      ...orderModel,
                      orderID: callback.id,
                      zoneIndex: undefined,
                    });
                    setAssignModel({
                      ...assignModel,
                      orderID: callback.id,
                      zoneIndex: undefined,
                      driverID: undefined,
                    });
                    setOrders();
                    setroutSelect();
                    setChangeZoom(true);
                  } else {
                    enqueueSnackbar("سفارشی یافت نشد", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    setOneOrderSearch("");
                    setLocations([]);
                    return;
                  }
                });
              }}
            >
              جستجو
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setOneOrderSearch("");
                setLocations([]);
                setOrders();
                setroutSelect();
              }}
            >
              جدید
            </Button>
          </Box>
        </Box>
        {routes && (
          <Box
            sx={{
              border: "1px solid #cdcdcd",
              borderRadius: 2,
              my: 2,
              // flexGrow: 1,
              height: isSmall ? "55rem" : "30rem",
              // maxHeight: "70%",
            }}
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
          >
            {/* <Box gridColumn="span 2"> */}
            <RoutsLists
              setMapCenter={setMapCenter}
              routes={routes}
              assignModel={assignModel}
              setAssignModel={setAssignModel}
              routSelect={routSelect}
              setroutSelect={setroutSelect}
              filters={filters}
              orderModel={orderModel}
              setChangeZoom={setChangeZoom}
              setOrders={setOrders}
              setOrderModel={setOrderModel}
              changeCenter={changeCenter}
              setChangeCenter={setChangeCenter}
              setOneOrderSearch={setOneOrderSearch}
              callback={(model) => {
                GetOrdersRoute(model, (call) => setLocations(call));
              }}
            />
            {/* </Box> */}
            <Box
              sx={{
                borderLeft: "1px solid #cdcdcd",
                borderRight: "1px solid #cdcdcd",
              }}
              gridColumn={isSmall ? "span 12" : "span 8"}
            >
              <MapComponent
                mapCenter={mapCenter}
                changeZoom={changeZoom}
                setChangeZoom={setChangeZoom}
                assignModel={assignModel}
                setAssignModel={setAssignModel}
                locations={locations}
                orderModel={orderModel}
                setOrderModel={setOrderModel}
                refreshDriver={refreshDriver}
                setRefreshDriver={setRefreshDriver}
                changeCenter={changeCenter}
                setChangeCenter={setChangeCenter}
              />
            </Box>
            <DriversCom
              setOneOrderSearch={setOneOrderSearch}
              setMapCenter={setMapCenter}
              routSelect={routSelect}
              setroutSelect={setroutSelect}
              filters={filters}
              orders={orders}
              setOrders={setOrders}
              setChangeZoom={setChangeZoom}
              setLocations={setLocations}
              setAssignModel={setAssignModel}
              setOrderModel={setOrderModel}
              refreshDriver={refreshDriver}
              setRefreshDriver={setRefreshDriver}
              changeCenter={changeCenter}
              setChangeCenter={setChangeCenter}
            />
          </Box>
        )}
        {routes && (
          <AssignDriver
            setMapCenter={setMapCenter}
            assignModel={assignModel}
            setAssignModel={setAssignModel}
            filters={filters}
            callback={() => refreshPage()}
            orderModel={orderModel}
          />
        )}
        {orders && orders.orders.length ? (
          <Box sx={{ height: "35rem", mt: 2 }} id="driversOrder">
            <OrdersListGrid
              callback={(driverId) => {
                let model = {
                  deliveryDate: filters.deliveryDate,
                  deliveryPart: filters.deliveryPart,
                  driverID: driverId,
                };
                setProgress(true);
                GetDriversRoutes(model, (orders) => {
                  setOrders(orders);
                });
              }}
              filters={filters}
              rows={orders ?? []}
            />
          </Box>
        ) : (
          ""
        )}
      </Box>
    </Detail>
  );
}
